/**
 * Query keys del dominio del Cotizador de puertas.
 *
 * Keys consistentes y serializables (`docs/frontend_conventions.md`, Datos). El historial y
 * sus estadísticas se filtran por la sede activa en el backend (vía `X-Sede-Id`), así que
 * cada key incluye la sede para **cachear por sede**: al cambiar de sede, el historial se
 * recarga (clave distinta) en vez de mostrar el de la sede anterior.
 *
 * El **cálculo** y los **tickets** NO se cachean por query key: son mutaciones (no son dato
 * de servidor idempotente, dependen del payload del formulario), igual que el SSR los pedía
 * por POST en cada COTIZAR.
 */

/** Raíz de las queries de historial de cotizador (para invalidación tras guardar). */
export const COTIZADOR_ROOT_KEY = ["cotizador"] as const;

/** Key del historial de cotizaciones, segmentada por sede, límite y filtro propio. */
export function cotizacionesQueryKey(sedeId: number | null, limit: number, mine: boolean) {
  return ["cotizador", "cotizaciones", { sede: sedeId, limit, mine }] as const;
}

/** Key de las estadísticas de error del historial, segmentada por sede, días y filtro. */
export function cotizacionStatsQueryKey(sedeId: number | null, days: number, mine: boolean) {
  return ["cotizador", "stats", { sede: sedeId, days, mine }] as const;
}
